import { makeObservable, observable, action, runInAction } from "mobx";
import dayjs from "dayjs";

import { LabelValue } from "../../../models/Dashboard/Analytics";
import VendorsAnalyticsDashboardAPI from "../api/VendorsAnalyticsDashboardAPI";
import { VendorsAnalyticsAPIFilters } from "../../../models/Dashboard/VendorDashboard/VendorsAnalyticsFilters";
import { ProposalAnalyticsAPIFilters } from "../../../models/Dashboard/ProposalDashboard/ProposalAnalyticsFilters";

export class VendorsAnalyticsStore {
  analyticsAPI: VendorsAnalyticsDashboardAPI;
  inward_tats: LabelValue[];
  report: any[] | null;
  proposal_tats: LabelValue[];

  constructor() {
    this.analyticsAPI = new VendorsAnalyticsDashboardAPI();
    this.inward_tats = [];
    this.proposal_tats = [];
    this.report = null;

    makeObservable(this, {
      inward_tats: observable,
      report: observable,
      getAllAnalyticsData: action,
      _getInwardTATs: action,
      getReportData: action,
    });
  }

  getReportData = async (url: string, filters: any) => {
    try {
      this.report = await this.analyticsAPI.getReportData(url, filters);
    } catch (error) {
      console.error("Error fetching Data", error);
      this.report = [];
    }
  };

  getProposalAnalyticsData = async (filters: ProposalAnalyticsAPIFilters) => {
    try {
      await Promise.all([this._getProposalTATs(filters)]);
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };

  getAllAnalyticsData = async (filters: VendorsAnalyticsAPIFilters) => {
    try {
      await Promise.all([this._getInwardTATs(filters)]);
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };

  _getProposalTATs = async (filters: ProposalAnalyticsAPIFilters) => {
    try {
      const data = (await this.analyticsAPI.getProposalTatsData(
        "/scorecard/tat/unique-proposal-viewers",
        filters
      )) as LabelValue[];
      this.proposal_tats = data;
    } catch (error) {
      throw error;
    }
  };

  _getInwardTATs = async (filters: VendorsAnalyticsAPIFilters) => {
    try {
      const data = (await this.analyticsAPI.getTatsData(
        "/scorecard",
        filters
      )) as LabelValue[];
      this.inward_tats = data;
    } catch (error) {
      throw error;
    }
  };
}
